export const fragranceAudiences = [
  { slug: "donna", name: { it: "Donna", en: "Women" } },
  { slug: "uomo", name: { it: "Uomo", en: "Men" } },
  { slug: "unisex", name: { it: "Unisex", en: "Unisex" } },
  { slug: "bambini", name: { it: "Bambini", en: "Kids" } },
];
export const fragranceAudience = (product) => product.category === "profumi"
  ? fragranceAudiences.find(a => a.slug === product.subcategory)?.name : null;
